<template>
    <div class="content">
        <p class="title">培育本土知名品牌 通过一码追溯 提升水泵品质 增强盐湖区水泵品牌的权威性和公信力</p>
        <p class="sub-title">为新技术、新产品、新工艺的研发设计、标准制订，向盐湖区水泵及市场提供专业化的鉴证依据、技术指导和公共检测服务
        </p>
        <div class="block_div flex">
            <div class="flex block_div_item" v-for="item in list" :key="item.title">
                <img :src="item.url" alt="" srcset="">
                <p class="item_title">{{ item.title }}</p>
                <p class="item_content">{{ item.text }}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            list: [
                {
                    url: require("@/assets/home/b_1.png"),
                    title: '品牌背书',
                    text: '每一台出自盐湖区的水泵都是通过公共检测服务中心的检测，每张认证标签代表着品牌和背书。'
                },
                {
                    url: require("@/assets/home/b_2.png"),
                    title: '质量背书',
                    text: '检测服务中心出具的检测数据和检测报告能够广泛应用于投标招标、质量认证、产品研发、政府质量监督等领域，具有“证明”或“公证”作用。'
                },
                {
                    url: require("@/assets/home/b_3.png"),
                    title: '提质降本',
                    text: '有效地解决了当地企业对成品出厂质量难以把关、送检成本高等困难。'
                },
                {
                    url: require("@/assets/home/b_4.png"),
                    title: '全流程追溯',
                    text: '检测服务中心提供全流程端到端的数据检测、存储、一站式产线赋码、在线查询，实现一物一码、一码追溯。'
                }
            ]
        }
    },
    created() { },
    methods() { },
}

</script>
<style lang="less" scoped>
.content {
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title {
        width: 1120px;
        height: 40px;
        font-size: 24px;
        font-family: ABCMarfa-Bold, ABCMarfa;
        font-weight: 400;
        color: #000000;
        line-height: 40px;
    }

    .sub-title {
        width: 864px;
        height: 44px;
        margin-top: 16px;
        font-size: 16px;
        font-family: ABCMarfa-Bold, ABCMarfa;
        font-weight: 400;
        color: #000000;
        line-height: 22px;
    }
   .block_div{
    margin-top: 12px;
    align-items: flex-start;
   }
    .block_div_item {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 260px;
        img {
            width: 58px;
            // height: 56px;
            object-fit: contain;
        }

        .item_title {
            font-size: 16px;
            font-family: ABCMarfa-Bold, ABCMarfa;
            font-weight: 600;
            color: #000000;
            line-height: 20px;
            margin-top: 11px;
            margin-bottom: 12px;
        }

        .item_content {
            font-size: 14px;
            font-family: ABCMarfa-Bold, ABCMarfa;
            font-weight: 400;
            color: #000000;
            line-height: 28px;
        }
        p{
            text-align: left;

        }
    }
    .block_div_item{
        margin-right: 54px;

    }
    .block_div_item:last-child{
        margin-right: 0;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/homeIndex/codeTracing.vue